import "./HomePage.css";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock, CalendarClock, ShieldCheck, Search, Calendar, CheckCircle } from "lucide-react";

import image1 from "../../image/mecanicien.jpeg";
import image2 from "../../image/artisan.jpg";
import image3 from "../../image/laveur_auto.jpg";

const images = [image1, image2, image3];

function HomePage() {
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_URL;

  const [role] = useState(localStorage.getItem("role"));
  const [token] = useState(localStorage.getItem("token"));

  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const hasAnnonce = (data) => {
    if (!data) return false;
    if (Array.isArray(data)) return data.length > 0;
    return Boolean(data._id);
  };

  const handleNavigate = async () => {
    const tk = localStorage.getItem("token");
    const rl = localStorage.getItem("role");
    const userId = localStorage.getItem("userId");

    if (tk && rl === "pro") {
      try {
        const res = await fetch(`${API}/api/annonces/by-user/${userId}`, {
          headers: tk ? { Authorization: `Bearer ${tk}` } : {},
          credentials: "include",
        });
        const data = await res.json().catch(() => null);

        if (res.ok && hasAnnonce(data)) {
          navigate("/pro/calendar");
        } else {
          navigate("/pro/profiles/select");
        }
      } catch {
        navigate("/pro/profiles/select");
      }
      return;
    }

    navigate("/search");
  };

  return (
    <div className="home">
      <div className="body_">
        <header className="home-hero">
          <h1 className="body_container_text_title">ProMeetService</h1>
          <p className="home-hero__tagline">
            La prise de rendez-vous simple entre particuliers et professionnels de l’automobile et des services de proximité.
          </p>
          <ul className="home-trust" aria-label="Atouts de la plateforme">
            <li className="home-trust__item">RDV en ligne</li>
            <li className="home-trust__item">Pros vérifiés</li>
            <li className="home-trust__item">Données protégées</li>
          </ul>
        </header>

        <nav className="home-flow" aria-label="Comment ça marche">
          <span className="home-flow__step">
            <Search size={17} strokeWidth={2} aria-hidden />
            <span>Recherche par métier et lieu</span>
          </span>
          <span className="home-flow__sep" aria-hidden>·</span>
          <span className="home-flow__step">
            <Calendar size={17} strokeWidth={2} aria-hidden />
            <span>Choix du créneau</span>
          </span>
          <span className="home-flow__sep" aria-hidden>·</span>
          <span className="home-flow__step">
            <CheckCircle size={17} strokeWidth={2} aria-hidden />
            <span>RDV confirmé</span>
          </span>
        </nav>

        <div className="body_container_flex">
          <div className="body_container_image">
            <motion.img
              key={index}
              src={images[index]}
              alt={`Slide ${index + 1}`}
              className="carousel_img"
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -100 }}
              transition={{ duration: 0.5 }}
            />

            <button type="button" className="button-trouve-pro" onClick={handleNavigate}>
              {token && role === "pro" ? "Mes rendez-vous" : "Trouver mon professionnel"}
            </button>

            <nav className="home-links" aria-label="Accès rapides">
              <Link className="home-links__link" to="/auth/signup/pro">
                Vous êtes professionnel ? Inscription pro
              </Link>
              <span className="home-links__sep" aria-hidden>·</span>
              <Link className="home-links__link" to="/auth/signup/client">
                Créer un compte client
              </Link>
            </nav>
          </div>

          <div className="body_container_text">
            <div className="body_container_points">
              <div className="point-cle">
                <div className="point-cle-icon" aria-hidden>
                  <Clock size={22} strokeWidth={2} />
                </div>
                <div className="point-cle-text">
                  Trouvez un rendez-vous rapidement : mécaniciens, nettoyage auto, artisans… en quelques clics, sans appels à répétition.
                </div>
              </div>

              <div className="point-cle">
                <div className="point-cle-icon" aria-hidden>
                  <CalendarClock size={22} strokeWidth={2} />
                </div>
                <div className="point-cle-text">
                  Des disponibilités à jour : la plateforme relie clients et pros pour limiter les doubles réservations et le va-et-vient inutile.
                </div>
              </div>

              <div className="point-cle">
                <div className="point-cle-icon" aria-hidden>
                  <ShieldCheck size={22} strokeWidth={2} />
                </div>
                <div className="point-cle-text">
                  Un parcours clair et sécurisé : moins de friction, plus de temps pour l’essentiel.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;

